function warn(message) {
  var _a, _b;
  return (_b = (_a = window.o_global) == null ? void 0 : _a.debug) == null ? void 0 : _b.warn(message);
}
function sendCustomRequest(type, data) {
  var _a, _b;
  if (typeof ((_b = (_a = window.AS) == null ? void 0 : _a.RUM) == null ? void 0 : _b.sendCustomRequest) === "function") {
    window.AS.RUM.sendCustomRequest(type, data);
  }
}
function deprecated(funcId, message = "") {
  const { stack } = Error("");
  warn(`${funcId} is deprecated, ${message}.`);
  sendCustomRequest("assets-legacy", {
    message: `${funcId}: ${message}`,
    stack,
    caller: stack == null ? void 0 : stack.split("\n")[2]
  });
}
function dateNow() {
  return new Date();
}
function getTime() {
  return dateNow().getTime();
}
function now() {
  return Date.now();
}
function random() {
  return Math.random();
}

export { dateNow as a, deprecated as d, getTime as g, now as n, random as r, sendCustomRequest as s, warn as w };
/*                                 */
